import type { CompPoints } from '@/api/compPoints';
import {
  type LoyaltyLevel,
  type LoyaltyLevelPrizeLabel,
  type LoyaltyLevelPrizeValues,
  loyaltyLevels,
} from '../data';

export interface LoyaltyDataI {
  level: number;
  nextLevel: number;
  prizeValues?: LoyaltyLevelPrizeValues;
  prizeLabel: LoyaltyLevelPrizeLabel;
  nextPrizeValues?: LoyaltyLevelPrizeValues;
  nextPrizeLabel: LoyaltyLevelPrizeLabel;
  currentCompPoints: number;
  fromCompPoints: number;
  toCompPoints: number;
}

export const detectLoyaltyData =
  (levelsData: LoyaltyLevel[]) =>
  (compPoints?: CompPoints): LoyaltyDataI => {
    const points = compPoints?.persistent?.points || 0;

    const currentIndexPoint = levelsData.findIndex(
      ({ cp }, index) =>
        points &&
        cp <= points &&
        (!levelsData[index + 1] || points < levelsData[index + 1].cp)
    );

    const {
      level = 0,
      prizeLabel,
      prizeValues,
      cp = 0,
    } = levelsData[currentIndexPoint] || {};
    const nextLevel = levelsData[currentIndexPoint + 1];

    return {
      level,
      nextLevel: nextLevel?.level || level + 1,
      prizeLabel,
      prizeValues,
      nextPrizeLabel: nextLevel?.prizeLabel,
      nextPrizeValues: nextLevel?.prizeValues,
      currentCompPoints: points,
      fromCompPoints: cp,
      toCompPoints: nextLevel?.cp || points,
    };
  };

export const generateLoyaltyData = detectLoyaltyData(loyaltyLevels);
